import React from 'react'

import Settings from 'Skelet/src/components/Settings.js'
import SettingsPassword from 'Skelet/src/components/SettingsPassword.js'

import config from '../config.js'


export default class extends React.Component {

  render() {
    return <div className="container thin-container" style={{marginTop:"2em"}}>
      <Settings
        config = {config}
        fields = {[{type:"display", dbcol:"email", placeholder:"Emailadres"},
        {type:"text", dbcol:"firstname", placeholder:"Voornaam", maxLength:"128"},
        {type:"text", dbcol:"lastname", placeholder:"Achternaam", maxLength:"128"}]}
        parameter_fields = {[{type:"select", dbcol:"gender", placeholder:"Geslacht", options:[{value:"f", label:"Vrouw"}, {value:"m", label:"Man"}], defaultValue:"f"},
        {type:"date", dbcol:"birthdate", placeholder:"JJJJ-MM-DD"},
        {type:"text", dbcol:"length", placeholder:"Lengte (in cm)", maxLength:"3"}]}
        required_fields = {[{dbcol:"firstname", name:"Voornaam"}, {dbcol:"lastname", name:"Achternaam"}]}
        validate_fields = {[{dbcol:"firstname", name:"Voornaam"}, {dbcol:"lastname", name:"Achternaam"}]}
        validate_parameter_fields = {[{dbcol:"length", name:"Lengte", type:"int"}]}
        api_method = "PATCH"
        api_endpoint = "/account-update"
        api_block = "update_account"
      />
      <div style={{marginTop:"2em"}}>
        <SettingsPassword
          lang = "NL"
          config = {config}
          api_method = "PATCH"
          api_endpoint = "/account-update"
          api_block = "update_account"
        />
      </div>
    </div>;
  }

}



// WEBPACK FOOTER //
// ./src/containers/Settings.js